'use client';

import { Body } from '@/components/body';
import { Heading } from '@/components/heading';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function MainBannerArchEng() {
  return (
    <div className="w-full md:px-8">
      <div className="bg-background-2 flex flex-col items-center justify-center md:rounded-lg min-h-[65svh]">
        <div className="flex flex-col justify-center items-center text-center gap-8 py-16 px-4 md:px-0">
          <Heading variant="h1" className="max-w-[56.625rem]">
            L&apos;assistente di intelligenza artificiale ideale per{' '}
            <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
              l&apos;ingegneria
            </span>{' '}
            e l&apos;architettura
          </Heading>
          <Body variant="large" className="max-w-[42rem]">
            Ricerca normativa e procedurale, analisi di pratiche e allegati
            tecnici, supporto alla redazione di bozze, checklist e modulistica.
            Meno tempo perso tra norme, portali e documenti. Più tempo per
            progetto, cliente e decisioni tecniche.
          </Body>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <Link href={`${process.env.NEXT_PUBLIC_NAI_APP_URL}/sign-up`}>
              <Button variant="default" size="default">
                Attiva la Prova Gratuita
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
